import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import EditParticipent from "../Edit/EditParticipent";
import IdCard from "./IdCard";
import ReactDOM from 'react-dom/client';
import EditControls from "./EditControls";
import VisibilityModal from "./VisibilityModal";
import DownloadButtons from "./DownloadButtons";
import SearchBar from "./SearchBar";
import { Search, RefreshCw, Calendar, Users, Tag, Edit } from "lucide-react";
import EditEvents from "../Edit/EditEvents";
import QRCode from "qrcode.react";

function IdCardrender({
  Dataid,
  fetchData,
  isLoading,
  eventName,
  fetchDesignations,
  eventId,
  eventData,
}) {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenedit, setIsModalOpenedit] = useState(false);
  const [elementStyles, setElementStyles] = useState({
    profilePicture: {
      bottom: 160,
      left: "50%",
      size: 170,
    },
    name: {
      top: 163,
      left: "50%",
      fontSize: 29,
      color: "black",
    },
    institute: {
      bottom: 293,
      left: "50%",
      fontSize: 18,
      color: "black",
    },
    designation: {
      bottom: 304,
      left: "50%",
      fontSize: 16,
      color: "black",
    },
    qrCode: {
      bottom: 215,
      left: "50%",
      size: 100,
    },
    participantId: {
      bottom: 3,
      left: "50%",
      fontSize: 12,
      color: "black",
    },
    ticketInfo: {
      bottom: 174,
      left: "50%",
      fontSize: 16,
      color: "black",
    },
    ticketDates: {
      bottom: 102,
      left: "50%",
      fontSize: 17,
      color: "black",
    },
  });

  const [isEditOpen, setIsEditOpen] = useState(false);

  const toggleEditModal = () => {
    setIsEditOpen((prev) => !prev);
  };

  const reloadComponent = () => {
    window.location.reload();
  };

  const [globalVisibility, setGlobalVisibility] = useState({
    name: true,
    profilePicture: true,
    institute: true,
    designation: true,
    qrCode: true,
    participantId: true,
    ticketInfo: false,
    ticketDates: false,
    isLandscapePrint: false,
  });
  const [previewCard, setPreviewCard] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [checkedInParticipants, setCheckedInParticipants] = useState({});
  const [loadingZip, setLoadingZip] = useState(false);
  const [loadingZipNoBg, setLoadingZipNoBg] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);

  useEffect(() => {
    fetchDesignSettings();
    fetchCheckinStatus();
    // eslint-disable-next-line
  }, [eventId]);

const fetchCheckinStatus = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/participants/checkins/${eventId}`
    );
    
    console.log("Check-in API response:", response.data);
    
    const checkinMap = {};
    
    // ✅ FIXED: Proper response handling
    let checkinData = [];
    
    if (Array.isArray(response.data)) {
      checkinData = response.data;
    } else if (response.data && typeof response.data === 'object') {
      checkinData = response.data.data || 
                    response.data.checkins || 
                    response.data.participants || 
                    response.data.results || 
                    [];
    }
    
    // ✅ Build the checkin map with time information
    if (Array.isArray(checkinData)) {
      checkinData.forEach((item) => {
        if (item && item.participantId) {
          checkinMap[item.participantId] = {
            isCheckedIn: true,
            checkinTime: item.checkinTime // ✅ Store check-in time
          };
        }
      });
    } else {
      console.warn("Check-in data is not in expected array format:", checkinData);
    }
    
    setCheckedInParticipants(checkinMap);
  } catch (error) {
    console.error("Error fetching check-in statuses:", error);
    setCheckedInParticipants({});
  }
};



  const fetchDesignSettings = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/participants/design/${eventId}`
      );
      if (response.data && response.data.elementStyles) {
        setElementStyles(response.data.elementStyles);
      }
      if (response.data && response.data.visibility) {
        setGlobalVisibility(response.data.visibility);
      }
    } catch (error) {
      console.error("Error fetching design settings:", error);
    }
  };

  const saveDesignSettings = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/participants/design/${eventId}`,
        {
          elementStyles,
          visibility: globalVisibility,
        }
      );
      Swal.fire("Success", "Design settings saved successfully", "success");
    } catch (error) {
      console.error("Error saving design settings:", error);
      Swal.fire("Error", "Failed to save design settings", "error");
    }
  };

  const handleCheckin = async (participantId) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/participants/participant/${participantId}/checkin`
      );
      Swal.fire({
        title: "Success!",
        text: "Participant checked in successfully",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
     // ✅ Update state with check-in time
      setCheckedInParticipants((prev) => ({
        ...prev,
        [participantId]: {
          isCheckedIn: true,
          checkinTime: data.checkinTime || new Date().toISOString()
        }
      }));
      return data;
    } catch (err) {
      console.error("Check-in error:", err);
      Swal.fire({
        title: "Error!",
        text: "Failed to check in participant",
        icon: "error",
      });
    }
  };

  const toggleModalOpen = () => setIsModalOpen((prev) => !prev);
  const toggleModalOpenedit = () => {
    if (!isModalOpenedit && Dataid.length > 0) {
      setPreviewCard(Dataid[Dataid.length - 1]);
    }
    setIsModalOpenedit((prev) => !prev);
  };

  const toggleGlobalVisibility = (field) => {
    setGlobalVisibility((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const updateElementStyle = (element, property, value) => {
    setElementStyles((prev) => ({
      ...prev,
      [element]: { ...prev[element], [property]: value },
    }));
    if (previewCard) setPreviewCard({ ...previewCard });
  };

  const filteredData = Array.isArray(Dataid)
    ? [...Dataid].reverse().filter((card) => {
      const term = searchTerm.toLowerCase();
      return (
        `${card.firstName} ${card.lastName}`.toLowerCase().includes(term) ||
        card.email?.toLowerCase().includes(term) ||
        card.participantId?.toLowerCase().includes(term) ||
        card.designation?.toLowerCase().includes(term)
      );
    })
    : [];
  const reversedData = filteredData;

  // FIXED: Added element existence check and error handling
  const downloadAllImagesAsZip = () => {
    setLoadingZip(true);
    const zip = new JSZip();

    const images = reversedData.map((_, index) => {
      return new Promise((resolve) => {
        const element = document.getElementById(`id-card-${index}`);

        // FIXED: Check if element exists before converting
        if (!element) {
          console.warn(`Element id-card-${index} not found, skipping...`);
          resolve(); // Skip this element
          return;
        }

        import("html-to-image").then(({ toPng }) => {
          toPng(element, {
            cacheBust: true,
            quality: 1,
            pixelRatio: 3,
            skipFonts: true,
            preferredFontFormat: "woff2",
          })
            .then((dataUrl) => {
              zip.file(`id-card-${index}.png`, dataUrl.split(",")[1], {
                base64: true,
              });
              resolve();
            })
            .catch((error) => {
              console.error(`Error converting id-card-${index}:`, error);
              resolve(); // Continue even if one fails
            });
        });
      });
    });

    Promise.all(images).then(() => {
      zip.generateAsync({ type: "blob" }).then((content) => {
        saveAs(content, "id-cards.zip");
        setLoadingZip(false);
      });
    });
  };

  // FIXED: Added skipFonts and preferredFontFormat
  const downloadAllImagesWithoutBackgroundAsZip = () => {
    setLoadingZipNoBg(true);
    const zip = new JSZip();
    const images = reversedData.map((_, index) => {
      return new Promise((resolve) => {
        const element = document.getElementById(`id-card-${index}`);
        const backgroundImage = element.querySelector("img");
        const originalDisplay = backgroundImage
          ? backgroundImage.style.display
          : null;
        if (backgroundImage) backgroundImage.style.display = "none";
        import("html-to-image").then(({ toPng }) => {
          toPng(element, {
            cacheBust: true,
            backgroundColor: null,
            quality: 1,
            pixelRatio: 3,
            skipFonts: true, // FIXED: Skip external font loading
            preferredFontFormat: "woff2", // FIXED: Prefer woff2 format
          })
            .then((dataUrl) => {
              zip.file(
                `id-card-${index}-no-background.png`,
                dataUrl.split(",")[1],
                { base64: true }
              );
              resolve();
            })
            .catch(() => resolve())
            .finally(() => {
              if (backgroundImage)
                backgroundImage.style.display = originalDisplay;
            });
        });
      });
    });
    Promise.all(images).then(() => {
      zip.generateAsync({ type: "blob" }).then((content) => {
        saveAs(content, "id-cards-no-background.zip");
        setLoadingZipNoBg(false);
      });
    });
  };

  const downloadAllEntries = () => {
    setLoadingExcel(true);
    console.log("reversedData", reversedData);
    const formattedData = reversedData.map((card, index) => ({
      "S.No": index + 1,
      EventName: card.eventName,
      EventID: card.eventId,
      FirstName: card.firstName,
      LastName: card.lastName,
      Designation: card.designation,
      Institute: card.institute,
      PhoneNumber: card.phone,
      ParticipantID: card.participantId,
      email: card.email,
      ProfilePicture: card.profilePicture,
      Amenities: JSON.stringify(card.amenities),
      CreatedAt: new Date(card.createdAt).toLocaleString(),
      UpdatedAt: new Date(card.updatedAt).toLocaleString(),
      CheckedIn: card.checkin,
      CheckInTime: card.checkinTime ? new Date(card.checkinTime).toLocaleString() : 'N/A',
    }));
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(formattedData);
    XLSX.utils.book_append_sheet(wb, ws, "ID Cards");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${eventName}_ID_Cards.xlsx`);
    setLoadingExcel(false);
  };

  // Add this function in IdCardrender.jsx after downloadAllEntries
const downloadAllCustomPNGVertical = async () => {
  setLoadingZip(true);
  const zip = new JSZip();

  // Show initial progress alert
  Swal.fire({
    title: 'Generating ID Cards',
    html: `
      <div style="text-align: center;">
        <div style="font-size: 24px; font-weight: bold; color: #3b82f6; margin-bottom: 10px;">
          <span id="current-progress">0</span> / ${reversedData.length}
        </div>
        <div style="background: #e5e7eb; border-radius: 10px; height: 20px; overflow: hidden; margin: 20px 0;">
          <div id="progress-bar" style="background: linear-gradient(90deg, #3b82f6, #8b5cf6); height: 100%; width: 0%; transition: width 0.3s;"></div>
        </div>
        <div style="color: #6b7280; font-size: 14px;">
          Processing: <span id="current-name" style="font-weight: 600; color: #1f2937;">Starting...</span>
        </div>
        <div style="color: #9ca3af; font-size: 12px; margin-top: 10px;">
          Estimated time: <span id="estimated-time">Calculating...</span>
        </div>
      </div>
    `,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  try {
    const htmlToImage = await import('html-to-image');
    const startTime = Date.now();
    
    for (let index = 0; index < reversedData.length; index++) {
      const card = reversedData[index];
      const currentProgress = index + 1;
      const progressPercent = (currentProgress / reversedData.length) * 100;
      
      // Calculate estimated time remaining
      const elapsed = Date.now() - startTime;
      const avgTimePerCard = elapsed / currentProgress;
      const remaining = (reversedData.length - currentProgress) * avgTimePerCard;
      const remainingSeconds = Math.ceil(remaining / 1000);
      const remainingMinutes = Math.floor(remainingSeconds / 60);
      const remainingSecondsDisplay = remainingSeconds % 60;
      
      const timeDisplay = remainingMinutes > 0 
        ? `${remainingMinutes}m ${remainingSecondsDisplay}s` 
        : `${remainingSeconds}s`;
      
      // Update progress UI
      const progressBar = document.getElementById('progress-bar');
      const currentProgressEl = document.getElementById('current-progress');
      const currentNameEl = document.getElementById('current-name');
      const estimatedTimeEl = document.getElementById('estimated-time');
      
      if (progressBar) progressBar.style.width = `${progressPercent}%`;
      if (currentProgressEl) currentProgressEl.textContent = currentProgress;
      if (currentNameEl) currentNameEl.textContent = `${card.firstName || ''} ${card.lastName || ''}`.trim();
      if (estimatedTimeEl) estimatedTimeEl.textContent = index === 0 ? 'Calculating...' : timeDisplay;
      
      // Generate QR Code as base64 image
      const participantUrl = card?._id 
        ? `http://idcard.insideoutprojects.in/checkin/${card._id}` 
        : "#";

      // Create QR code canvas
      const qrCanvas = document.createElement('canvas');
      const QRCodeLib = (await import('qrcode')).default;
      await QRCodeLib.toCanvas(qrCanvas, participantUrl, {
        width: 150,
        margin: 1,
        errorCorrectionLevel: 'H'
      });
      const qrDataUrl = qrCanvas.toDataURL('image/png');

      // Get ticket info
      const ticketDetails = card.ticketDetails;
      const category = card?.ticketCategory;
      const selectedDates = ticketDetails?.selectedDates;
      
      const formatTicketDates = (dates) => {
        if (!dates || dates.length === 0) return "";
        return dates
          .map((date) =>
            new Date(date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })
          )
          .join(", ");
      };

      const formattedDates = selectedDates ? formatTicketDates(selectedDates) : '';
      const fullName = `${card.firstName || ''} ${card.lastName || ''}`.trim();

      // Dynamic font sizing
      const getNameFontSize = (name) => {
        const length = name.length;
        if (length <= 10) return '16px';
        if (length <= 15) return '14px';
        if (length <= 20) return '13px';
        if (length <= 25) return '12px';
        return '11px';
      };

      const getCategoryFontSize = (cat) => {
        if (!cat) return '11px';
        const length = cat.length;
        if (length <= 10) return '12px';
        if (length <= 15) return '11px';
        return '10px';
      };

      const nameFontSize = getNameFontSize(fullName);
      const categoryFontSize = getCategoryFontSize(category);

      // Create the element with proper structure
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.style.width = '189px'; // 50mm
      tempDiv.style.height = '265px'; // 70mm
      tempDiv.style.background = 'white';
      tempDiv.style.display = 'flex';
      tempDiv.style.alignItems = 'center';
      tempDiv.style.justifyContent = 'center';
      
      // Create rotated inner div
      const rotatedDiv = document.createElement('div');
      rotatedDiv.style.transform = 'rotate(-90deg)';
      rotatedDiv.style.transformOrigin = 'center center';
      rotatedDiv.style.width = '265px'; // 70mm
      rotatedDiv.style.height = '189px'; // 50mm
      rotatedDiv.style.background = 'white';
      rotatedDiv.style.display = 'flex';
      rotatedDiv.style.flexDirection = 'row';
      rotatedDiv.style.alignItems = 'center';
      rotatedDiv.style.justifyContent = 'center';
      rotatedDiv.style.padding = '11px';
      rotatedDiv.style.boxSizing = 'border-box';
      rotatedDiv.style.fontFamily = 'Arial, sans-serif';
      rotatedDiv.style.gap = '11px';

      // Left side - Text content
      const leftDiv = document.createElement('div');
      leftDiv.style.display = 'flex';
      leftDiv.style.flexDirection = 'column';
      leftDiv.style.alignItems = 'flex-start';
      leftDiv.style.justifyContent = 'center';
      leftDiv.style.gap = '7px';
      leftDiv.style.flex = '1';

      // Name
      const nameDiv = document.createElement('div');
      nameDiv.style.fontSize = nameFontSize;
      nameDiv.style.fontWeight = 'bold';
      nameDiv.style.color = 'black';
      nameDiv.style.textAlign = 'left';
      nameDiv.style.lineHeight = '1.1';
      nameDiv.style.whiteSpace = 'nowrap';
      nameDiv.style.overflow = 'hidden';
      nameDiv.style.textOverflow = 'ellipsis';
      nameDiv.style.maxWidth = '100%';
      nameDiv.textContent = fullName;
      leftDiv.appendChild(nameDiv);

      // Category
      if (category) {
        const categoryDiv = document.createElement('div');
        categoryDiv.style.fontSize = categoryFontSize;
        categoryDiv.style.fontWeight = 'bold';
        categoryDiv.style.color = 'black';
        categoryDiv.style.textAlign = 'left';
        categoryDiv.style.whiteSpace = 'nowrap';
        categoryDiv.style.overflow = 'hidden';
        categoryDiv.style.textOverflow = 'ellipsis';
        categoryDiv.style.maxWidth = '100%';
        categoryDiv.textContent = category;
        leftDiv.appendChild(categoryDiv);
      }

      // Dates
      if (formattedDates) {
        const datesDiv = document.createElement('div');
        datesDiv.style.fontSize = '9px';
        datesDiv.style.fontWeight = 'normal';
        datesDiv.style.color = 'black';
        datesDiv.style.textAlign = 'left';
        datesDiv.style.whiteSpace = 'nowrap';
        datesDiv.style.overflow = 'hidden';
        datesDiv.style.textOverflow = 'ellipsis';
        datesDiv.style.maxWidth = '100%';
        datesDiv.textContent = formattedDates;
        leftDiv.appendChild(datesDiv);
      }

      // Right side - QR code section
      const rightDiv = document.createElement('div');
      rightDiv.style.display = 'flex';
      rightDiv.style.flexDirection = 'column';
      rightDiv.style.alignItems = 'center';
      rightDiv.style.justifyContent = 'center';
      rightDiv.style.gap = '3px';

      // QR text
      const qrText = document.createElement('div');
      qrText.style.fontSize = '10.67px';
      qrText.style.fontWeight = 'bold';
      qrText.style.color = 'black';
      qrText.style.textAlign = 'center';
      qrText.style.whiteSpace = 'nowrap';
      qrText.textContent = eventData?.qrCodeText || 'Show at the Venue';
      rightDiv.appendChild(qrText);

      // QR image
      const qrImg = document.createElement('img');
      qrImg.src = qrDataUrl;
      qrImg.style.width = '83px';
      qrImg.style.height = '83px';
      qrImg.style.display = 'block';
      rightDiv.appendChild(qrImg);

      // Append everything
      rotatedDiv.appendChild(leftDiv);
      rotatedDiv.appendChild(rightDiv);
      tempDiv.appendChild(rotatedDiv);
      document.body.appendChild(tempDiv);

      // Wait for image to load
      await new Promise(resolve => {
        if (qrImg.complete) {
          resolve();
        } else {
          qrImg.onload = resolve;
        }
      });

      // Small delay to ensure rendering
      await new Promise(resolve => setTimeout(resolve, 100));

      // Convert to PNG with higher quality
      const dataUrl = await htmlToImage.toPng(tempDiv, {
        cacheBust: true,
        quality: 1,
        pixelRatio: 3,
        backgroundColor: '#ffffff',
        skipFonts: false,
      });

      document.body.removeChild(tempDiv);

      // Add to zip
      const fileName = `id-card-${card.participantId || `${card.firstName}_${card.lastName}` || index}.png`;
      zip.file(fileName, dataUrl.split(',')[1], { base64: true });
      
      console.log(`✅ Generated ${currentProgress}/${reversedData.length}: ${fileName}`);
    }

    // Generate and download zip
    Swal.update({
      html: `
        <div style="text-align: center;">
          <div style="font-size: 18px; font-weight: bold; color: #10b981; margin-bottom: 10px;">
            Creating ZIP file...
          </div>
          <div style="color: #6b7280; font-size: 14px;">
            Please wait while we compress ${reversedData.length} images
          </div>
        </div>
      `
    });

    const content = await zip.generateAsync({ 
      type: 'blob',
      compression: "DEFLATE",
      compressionOptions: { level: 6 }
    });
    
    saveAs(content, `${eventName}_vertical_id_cards.zip`);
    
    // Success message
    Swal.fire({
      icon: 'success',
      title: 'Download Complete!',
      html: `
        <div style="text-align: center;">
          <div style="font-size: 16px; color: #6b7280; margin-top: 10px;">
            Successfully generated <strong>${reversedData.length} ID cards</strong>
          </div>
          <div style="font-size: 14px; color: #9ca3af; margin-top: 5px;">
            Total time: ${Math.ceil((Date.now() - startTime) / 1000)}s
          </div>
        </div>
      `,
      confirmButtonText: 'Done',
      confirmButtonColor: '#3b82f6'
    });
    
  } catch (error) {
    console.error('Error generating bulk PNG:', error);
    Swal.fire({
      icon: 'error',
      title: 'Generation Failed',
      text: `Failed to generate PNG images: ${error.message}`,
      confirmButtonColor: '#ef4444'
    });
  } finally {
    setLoadingZip(false);
  }
};
const downloadAllCustomPDFVertical = async () => {
  setLoadingZip(true);

  // Show initial progress alert
  Swal.fire({
    title: 'Generating ID Cards',
    html: `
      <div style="text-align: center;">
        <div style="font-size: 24px; font-weight: bold; color: #3b82f6; margin-bottom: 10px;">
          <span id="current-progress">0</span> / ${reversedData.length}
        </div>
        <div style="background: #e5e7eb; border-radius: 10px; height: 20px; overflow: hidden; margin: 20px 0;">
          <div id="progress-bar" style="background: linear-gradient(90deg, #3b82f6, #8b5cf6); height: 100%; width: 0%; transition: width 0.3s;"></div>
        </div>
        <div style="color: #6b7280; font-size: 14px;">
          Processing: <span id="current-name" style="font-weight: 600; color: #1f2937;">Starting...</span>
        </div>
        <div style="color: #9ca3af; font-size: 12px; margin-top: 10px;">
          Estimated time: <span id="estimated-time">Calculating...</span>
        </div>
      </div>
    `,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  try {
    const html2canvas = (await import('html2canvas')).default;
    const { jsPDF } = await import('jspdf');
    
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [50, 70]
    });

    const startTime = Date.now();
    let isFirstPage = true;

    for (let index = 0; index < reversedData.length; index++) {
      const card = reversedData[index];
      const currentProgress = index + 1;
      const progressPercent = (currentProgress / reversedData.length) * 100;

      // Calculate estimated time remaining
      const elapsed = Date.now() - startTime;
      const avgTimePerCard = elapsed / currentProgress;
      const remaining = (reversedData.length - currentProgress) * avgTimePerCard;
      const remainingSeconds = Math.ceil(remaining / 1000);
      const remainingMinutes = Math.floor(remainingSeconds / 60);
      const remainingSecondsDisplay = remainingSeconds % 60;

      const timeDisplay = remainingMinutes > 0 
        ? `${remainingMinutes}m ${remainingSecondsDisplay}s` 
        : `${remainingSeconds}s`;

      // Update progress UI
      const progressBar = document.getElementById('progress-bar');
      const currentProgressEl = document.getElementById('current-progress');
      const currentNameEl = document.getElementById('current-name');
      const estimatedTimeEl = document.getElementById('estimated-time');

      if (progressBar) progressBar.style.width = `${progressPercent}%`;
      if (currentProgressEl) currentProgressEl.textContent = currentProgress;
      if (currentNameEl) currentNameEl.textContent = `${card.firstName || ''} ${card.lastName || ''}`.trim();
      if (estimatedTimeEl) estimatedTimeEl.textContent = index === 0 ? 'Calculating...' : timeDisplay;

      // Add new page for each card (except first)
      if (!isFirstPage) {
        pdf.addPage([50, 70], 'portrait');
      }
      isFirstPage = false;

      // Generate QR Code
      const participantUrl = card?._id 
        ? `http://idcard.insideoutprojects.in/checkin/${card._id}` 
        : "#";

      const tempContainer = document.createElement('div');
      tempContainer.style.position = 'absolute';
      tempContainer.style.left = '-9999px';
      document.body.appendChild(tempContainer);

      const qrWrapper = document.createElement('div');
      tempContainer.appendChild(qrWrapper);

      const { createRoot } = await import('react-dom/client');
      const root = createRoot(qrWrapper);
      
      await new Promise((resolve) => {
        root.render(
          <QRCode
            value={participantUrl}
            size={150}
            level="H"
            id="temp-qr-code"
          />
        );
        setTimeout(resolve, 100);
      });

      const qrCanvas = qrWrapper.querySelector('canvas');
      const qrDataUrl = qrCanvas ? qrCanvas.toDataURL('image/png') : '';
      
      root.unmount();
      document.body.removeChild(tempContainer);

      // Get ticket info
      const ticketDetails = card.ticketDetails;
      const category = card?.ticketCategory;
      const selectedDates = ticketDetails?.selectedDates;

      const formatTicketDates = (dates) => {
        if (!dates || dates.length === 0) return "";
        return dates
          .map((date) =>
            new Date(date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })
          )
          .join(", ");
      };

      const formattedDates = selectedDates ? formatTicketDates(selectedDates) : '';
      const fullName = `${card.firstName || ''} ${card.lastName || ''}`.trim();

      // Dynamic font sizing
      const getNameFontSize = (name) => {
        const length = name.length;
        if (length <= 10) return '16px';
        if (length <= 15) return '14px';
        if (length <= 20) return '13px';
        if (length <= 25) return '12px';
        return '11px';
      };

      const getCategoryFontSize = (cat) => {
        if (!cat) return '11px';
        const length = cat.length;
        if (length <= 10) return '12px';
        if (length <= 15) return '11px';
        return '10px';
      };

      const nameFontSize = getNameFontSize(fullName);
      const categoryFontSize = getCategoryFontSize(category);

      // EXACT HTML from handleCustomPrint
      const horizontalContent = `
        <div style="
          width: 70mm;
          height: 50mm;
          background: white;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          padding: 3mm;
          box-sizing: border-box;
          font-family: Arial, sans-serif;
          gap: 3mm;
        ">
          <div style="
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 2mm;
            flex: 1;
            overflow: visible;
          ">
            <div style="
              font-size: ${nameFontSize};
              font-weight: bold;
              color: black;
              text-align: left;
              line-height: 1.1;
              word-wrap: break-word;
              overflow-wrap: break-word;
              max-width: 100%;
            ">
              ${fullName}
            </div>
            ${category ? `
              <div style="
                font-size: ${categoryFontSize};
                font-weight: bold;
                color: black;
                text-align: left;
                word-wrap: break-word;
                overflow-wrap: break-word;
                max-width: 100%;
              ">
                ${category}
              </div>
            ` : ''}
            ${formattedDates ? `
              <div style="
                font-size: 9px;
                font-weight: normal;
                color: black;
                text-align: left;
                word-wrap: break-word;
                overflow-wrap: break-word;
                max-width: 100%;
              ">
                ${formattedDates}
              </div>
            ` : ''}
          </div>

          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 1mm;
          ">
            <div style="
              font-size: 8pt;
              font-weight: bold;
              color: black;
              text-align: center;
              white-space: nowrap;
            ">
              ${eventData?.qrCodeText || 'Show at the Venue'}
            </div>
            <img src="${qrDataUrl}" style="width: 22mm; height: 22mm; display: block;" />
          </div>
        </div>
      `;

      // Create container with proper sizing
      const container = document.createElement('div');
      container.style.position = 'absolute';
      container.style.left = '-9999px';
      container.style.width = '189px'; // 50mm at 96dpi
      container.style.height = '265px'; // 70mm at 96dpi
      container.style.display = 'flex';
      container.style.alignItems = 'center';
      container.style.justifyContent = 'center';
      container.style.background = 'white';
      container.style.overflow = 'visible';
      
      const rotatedContent = document.createElement('div');
      rotatedContent.style.transform = 'rotate(-90deg)';
      rotatedContent.style.transformOrigin = 'center center';
      rotatedContent.style.width = '265px'; // 70mm
      rotatedContent.style.height = '189px'; // 50mm
      rotatedContent.style.overflow = 'visible';
      rotatedContent.innerHTML = horizontalContent;
      
      container.appendChild(rotatedContent);
      document.body.appendChild(container);

      // Wait for image to load
      const img = container.querySelector('img');
      await new Promise(resolve => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = resolve;
          img.onerror = resolve;
        }
      });

      // Longer delay for proper rendering
      await new Promise(resolve => setTimeout(resolve, 300));

      // Capture with html2canvas with better settings
      const canvas = await html2canvas(container, {
        backgroundColor: '#ffffff',
        scale: 3, // Higher scale for better quality
        width: 189,
        height: 265,
        useCORS: true,
        allowTaint: true,
        logging: false,
        windowWidth: 189,
        windowHeight: 265
      });

      document.body.removeChild(container);

      // Convert canvas to image and add to PDF
      const imgData = canvas.toDataURL('image/png', 1.0);
      pdf.addImage(imgData, 'PNG', 0, 0, 50, 70);

      console.log(`✅ Generated ${currentProgress}/${reversedData.length}: ${fullName}`);
    }

    // Save PDF
    Swal.update({
      html: `
        <div style="text-align: center;">
          <div style="font-size: 18px; font-weight: bold; color: #10b981; margin-bottom: 10px;">
            Creating PDF file...
          </div>
          <div style="color: #6b7280; font-size: 14px;">
            Finalizing ${reversedData.length} ID cards
          </div>
        </div>
      `
    });

    pdf.save(`${eventName}_vertical_id_cards.pdf`);

    // Success message
    Swal.fire({
      icon: 'success',
      title: 'Download Complete!',
      html: `
        <div style="text-align: center;">
          <div style="font-size: 16px; color: #6b7280; margin-top: 10px;">
            Successfully generated <strong>${reversedData.length} ID cards</strong>
          </div>
          <div style="font-size: 14px; color: #9ca3af; margin-top: 5px;">
            Total time: ${Math.ceil((Date.now() - startTime) / 1000)}s
          </div>
        </div>
      `,
      confirmButtonText: 'Done',
      confirmButtonColor: '#3b82f6'
    });

  } catch (error) {
    console.error('Error generating bulk PDF:', error);
    Swal.fire({
      icon: 'error',
      title: 'Generation Failed',
      text: `Failed to generate PDF: ${error.message}`,
      confirmButtonColor: '#ef4444'
    });
  } finally {
    setLoadingZip(false);
  }
};







  if (!Array.isArray(Dataid) || Dataid.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-lg font-bold text-center">
          No ID cards found for this event.
        </p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-10">
      <div className="w-full max-w-4xl mx-auto pt-3 relative">
        {/* Professional background accent */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-200 via-blue-100 to-gray-50 rounded-2xl opacity-20 -m-4"></div>

        {/* Subtitle or Additional Info */}
        <div className="flex justify-center relative">
          <div className="flex text-2xl items-center space-x-4 text-slate-700 font-semibold relative group">
            {/* Left decorative line with professional gradient */}
            <div className="w-12 h-px bg-gradient-to-r from-transparent via-slate-400 to-blue-500 opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>

            {/* Main title with professional styling */}
            <span className="relative px-4 py-2 bg-gradient-to-r from-gray-200 via-slate-300 to-blue-100 rounded-lg shadow-sm border border-slate-200/50 group-hover:shadow-md group-hover:border-slate-300/60 transition-all duration-300">
              <span className="bg-gradient-to-r from-slate-700 via-slate-800 to-blue-800 bg-clip-text text-transparent font-bold">
                {eventName}
              </span>
              <span className="text-slate-600 font-medium ml-2">All ID's</span>

              {/* Subtle shine effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 rounded-lg pointer-events-none"></div>
            </span>

            {/* Right decorative line with professional gradient */}
            <div className="w-12 h-px bg-gradient-to-l from-transparent via-slate-400 to-blue-500 opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
          </div>
        </div>

        {/* Professional accent dots */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute top-4 left-1/4 w-1 h-1 bg-blue-400 rounded-full opacity-20 animate-pulse delay-0"></div>
          <div className="absolute top-6 right-1/4 w-0.5 h-0.5 bg-slate-400 rounded-full opacity-30 animate-pulse delay-1000"></div>
        </div>

        {/* Subtle professional grid pattern */}
        <div className="absolute inset-0 opacity-[0.01] pointer-events-none">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `radial-gradient(circle at 1px 1px, rgb(51 65 85) 1px, transparent 0)`,
              backgroundSize: "16px 16px",
            }}
          ></div>
        </div>
      </div>

      {/* Search */}
      <div className="w-full max-w-4xl mx-auto py-3 relative">
        {/* Professional background */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-gray-50 to-blue-50 rounded-2xl opacity-30 -m-2"></div>

        <div className="relative flex flex-col sm:flex-row gap-4 items-center justify-center">
          {/* Search Input Container */}
          <div className="relative w-full sm:w-auto flex-1 max-w-2xl">
            <div className="relative group">
              {/* Search Icon */}
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <Search className="h-5 w-5 text-slate-400 group-focus-within:text-blue-600 transition-colors duration-300" />
              </div>

              {/* Search Input */}
              <input
                type="text"
                placeholder="Search by name, email, ID or designation…"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full h-14 pl-12 pr-6 bg-gradient-to-r from-white via-slate-50 to-gray-50 border-2 border-slate-300 rounded-lg shadow-lg focus:shadow-xl focus:from-blue-50 focus:via-white focus:to-slate-50 focus:border-blue-500 focus:outline-none transition-all duration-300 ease-out text-slate-900 placeholder-slate-500 font-medium hover:border-slate-400 hover:shadow-lg hover:from-slate-50 hover:to-white"
              />

              {/* Input Professional Glow Effect */}
              <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 opacity-0 group-focus-within:opacity-5 transition-opacity duration-300 pointer-events-none"></div>

              {/* Subtle shimmer effect */}
              <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-focus-within:opacity-100 transition-opacity duration-500 transform translate-x-[-100%] group-focus-within:translate-x-[100%] transition-transform duration-1000 pointer-events-none"></div>
            </div>

            {/* Search Results Count or Status */}
            {searchTerm && (
              <div className="absolute -bottom-6 left-4 text-xs  text-slate-600 font-medium   px-2 py-1 rounded-md shadow-sm">
                Searching for "{searchTerm}"
              </div>
            )}
          </div>

          {/* Professional Reload Button */}
          <div className="flex-shrink-0 gap-2">
            <button
              className="group relative overflow-hidden bg-gradient-to-r from-slate-700 via-slate-800 to-gray-800 hover:from-slate-600 hover:via-slate-700 hover:to-gray-700 text-white font-semibold py-4 px-6 rounded-lg shadow-lg hover:shadow-slate-500/20 hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300 ease-out border border-slate-600/30 hover:border-slate-500/50 min-w-[140px]"
              onClick={fetchData}
            >
              <div className="flex items-center justify-center space-x-3 relative z-10">
                <RefreshCw className="w-5 h-5 group-hover:rotate-180 transition-transform duration-500 ease-in-out" />
                <span className="text-sm font-medium">Reload</span>
              </div>

              {/* Professional Button Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>

              {/* Professional Ripple Effect */}
              <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-active:opacity-100 transform -translate-x-full group-active:translate-x-full transition-all duration-300"></div>
            </button>

            <button
              className="group ml-2 relative overflow-hidden bg-gradient-to-r from-slate-700 via-slate-800 to-gray-800 hover:from-slate-600 hover:via-slate-700 hover:to-gray-700 text-white font-semibold py-4 px-6 rounded-lg shadow-lg hover:shadow-slate-500/20 hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300 ease-out border border-slate-600/30 hover:border-slate-500/50 min-w-[140px]"
              onClick={toggleEditModal}
            >
              <div className="flex items-center justify-center space-x-3 relative z-10">
                <Edit className="w-5 h-5 group-hover:rotate-180 transition-transform duration-500 ease-in-out" />
                <span className="text-sm font-medium">Edit</span>
              </div>

              {/* Professional Button Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>

              {/* Professional Ripple Effect */}
              <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-active:opacity-100 transform -translate-x-full group-active:translate-x-full transition-all duration-300"></div>
            </button>
          </div>
        </div>

        {/* Professional subtle accents */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute top-2 left-8 w-1 h-1 bg-blue-400 rounded-full opacity-20 animate-pulse delay-0"></div>
          <div className="absolute bottom-2 right-8 w-0.5 h-0.5 bg-slate-400 rounded-full opacity-30 animate-pulse delay-1000"></div>
        </div>
      </div>

      {/* Download/Edit/Visibility */}
      <DownloadButtons
        loadingZip={loadingZip}
        loadingZipNoBg={loadingZipNoBg}
        loadingExcel={loadingExcel}
        downloadAllImagesAsZip={downloadAllImagesAsZip}
        downloadAllImagesWithoutBackgroundAsZip={
          downloadAllImagesWithoutBackgroundAsZip
        }
        downloadAllCustomPNGVertical={downloadAllCustomPNGVertical} 
        downloadAllCustomPDFVertical={downloadAllCustomPDFVertical}
        downloadAllEntries={downloadAllEntries}
        toggleModalOpenedit={toggleModalOpenedit}
        toggleModalOpen={toggleModalOpen}
        eventData={eventData}
        participants={Dataid}
      />

      {isEditOpen && (
        <EditEvents
          event={eventData}
          onClose={() => setIsEditOpen(false)}
          fetchEvents={reloadComponent}
        />
      )}

      {/* Edit All Modal */}
      {isModalOpenedit && (
        <EditControls
          previewCard={previewCard}
          elementStyles={elementStyles}
          setElementStyles={setElementStyles}
          setPreviewCard={setPreviewCard}
          globalVisibility={globalVisibility}
          saveDesignSettings={saveDesignSettings}
          toggleModalOpenedit={toggleModalOpenedit}
          reversedData={reversedData}
          fetchData={fetchData}
          isLoading={isLoading}
          fetchDesignations={fetchDesignations}
          eventId={eventId}
          checkedInParticipants={checkedInParticipants}
          handleCheckin={handleCheckin}
        />
      )}
      {/* Visibility Modal */}
      {isModalOpen && (
        <VisibilityModal
          globalVisibility={globalVisibility}
          toggleGlobalVisibility={toggleGlobalVisibility}
          saveDesignSettings={saveDesignSettings}
          toggleModalOpen={toggleModalOpen}
        />
      )}
      {/* Cards */}
      <div className="flex flex-wrap justify-center gap-10 ">
        {reversedData.slice(0, 15).map((card, index) => (
          <IdCard
            key={index}
            card={card}
            fetchData={fetchData}
            index={index}
            isLoading={isLoading}
            fetchDesignations={fetchDesignations}
            eventId={eventId}
            reversedData={reversedData}
            globalVisibility={globalVisibility}
            elementStyles={elementStyles}
            checkedInParticipants={checkedInParticipants}
            handleCheckin={handleCheckin}
            eventData={eventData}
          />
        ))}
      </div>
    </div>
  );
}

export default IdCardrender;
